import { Phone, Mail, MapPin, Clock, Navigation } from "lucide-react";
import SEO from "../components/site/SEO";
import Reveal from "../components/site/Reveal";
import { FormulaireDevis } from "../components/site/DevisForm";
import { useConfig } from "../components/Layout";
import { GARAGE, IMAGES } from "../lib/constants";

export default function Contact() {
  const config = useConfig();
  const fermeture = config?.fermeture;

  return (
    <>
      <SEO
        title="Contact — Garage Promo Pneus au Cannet | 04 93 46 39 67"
        description="Contactez Promo Pneus au Cannet : 04 93 46 39 67, 40 chemin du Périer. Sans rendez-vous du lundi au samedi. Près de Cannes, Mougins et Mandelieu."
      />
      <section className="relative bg-brand-dark py-16 sm:py-24 overflow-hidden">
        <img src={IMAGES.devanture} alt="Devanture du garage Promo Pneus au Cannet"
          className="absolute inset-0 w-full h-full object-cover opacity-25" loading="lazy" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="font-heading font-semibold uppercase tracking-[0.3em] text-brand-red text-base mb-3">
              {"//"} On vous attend
            </p>
            <h1 className="font-heading font-bold uppercase text-5xl sm:text-6xl md:text-7xl text-white tracking-wide leading-none">
              Contact
            </h1>
            <p className="mt-6 inline-block bg-brand-red text-white font-heading font-semibold uppercase tracking-wide text-lg sm:text-xl px-6 py-4" data-testid="contact-sans-rdv">
              Nous travaillons sans rendez-vous. Passez directement à l'atelier aux heures d'ouverture.
            </p>
            {fermeture && (
              <p className="mt-4 block bg-brand-navy text-white font-heading font-semibold uppercase tracking-wide text-base sm:text-lg px-6 py-4" data-testid="contact-fermeture">
                Fermeture exceptionnelle du {fermeture.debut.split("-").reverse().join("/")} au {fermeture.fin.split("-").reverse().join("/")}
                {fermeture.motif ? ` — ${fermeture.motif}` : ""}
              </p>
            )}
          </Reveal>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="space-y-8">
              <div>
                <h2 className="font-heading font-semibold uppercase text-3xl text-brand-dark tracking-tight mb-6">
                  Coordonnées
                </h2>
                <ul className="space-y-5">
                  <li>
                    <a href={`tel:${GARAGE.telephoneLien}`} data-testid="contact-telephone"
                      className="flex items-center gap-4 group">
                      <span className="bg-brand-red p-3.5 group-hover:bg-brand-redhover transition-colors">
                        <Phone size={24} className="text-white" aria-hidden="true" />
                      </span>
                      <span>
                        <span className="block text-sm font-heading uppercase tracking-wider text-brand-body">Téléphone</span>
                        <span className="font-heading font-bold text-2xl text-brand-dark group-hover:text-brand-red transition-colors">{GARAGE.telephone}</span>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href={`mailto:${GARAGE.email}`} data-testid="contact-email" className="flex items-center gap-4 group">
                      <span className="bg-brand-dark p-3.5 group-hover:bg-black transition-colors">
                        <Mail size={24} className="text-white" aria-hidden="true" />
                      </span>
                      <span>
                        <span className="block text-sm font-heading uppercase tracking-wider text-brand-body">Email — le plus sûr</span>
                        <span className="font-heading font-semibold text-xl text-brand-dark group-hover:text-brand-red transition-colors break-all">{GARAGE.email}</span>
                      </span>
                    </a>
                  </li>
                  <li className="flex items-center gap-4">
                    <span className="bg-brand-dark p-3.5">
                      <MapPin size={24} className="text-white" aria-hidden="true" />
                    </span>
                    <span>
                      <span className="block text-sm font-heading uppercase tracking-wider text-brand-body">Adresse</span>
                      <span className="font-heading font-semibold text-xl text-brand-dark">{GARAGE.adresse}</span>
                    </span>
                  </li>
                  <li className="flex items-center gap-4">
                    <span className="bg-brand-dark p-3.5">
                      <Clock size={24} className="text-white" aria-hidden="true" />
                    </span>
                    <span>
                      <span className="block text-sm font-heading uppercase tracking-wider text-brand-body">Horaires</span>
                      <span className="font-heading font-semibold text-xl text-brand-dark">{GARAGE.horairesTexte}</span>
                    </span>
                  </li>
                </ul>
                <a href={GARAGE.mapsItineraire} target="_blank" rel="noopener noreferrer" data-testid="contact-itineraire"
                  className="mt-8 inline-flex items-center gap-3 bg-brand-dark hover:bg-black text-white font-heading font-semibold uppercase tracking-wider text-lg px-8 py-4 transition-colors">
                  <Navigation size={20} aria-hidden="true" />
                  Itinéraire
                </a>
              </div>
              <iframe
                title="Carte : Promo Pneus, 40 chemin du Périer, 06110 Le Cannet"
                src={GARAGE.mapsEmbed}
                className="w-full h-80 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="bg-brand-light p-6 sm:p-10 h-max">
              <h2 className="font-heading font-semibold uppercase text-3xl text-brand-dark tracking-tight mb-3">
                Écrivez-nous
              </h2>
              <p className="text-brand-body mb-8">
                L'atelier décroche peu en journée : le moyen le plus sûr de nous joindre, c'est ce formulaire.
                Réponse sous 24 h ouvrées.
              </p>
              <FormulaireDevis compact />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
